export default {
  getHead: () => {
    return [{ name: '사업장명' }, { name: '피재자 성명' }, { name: '사고장소' }, { name: '직종(재해자)' }, { name: '작성부서' }, { name: '작성일' }]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 사업장명
      case 1: return func.onNameBlur(func.getContent(value).inputB_1) // 피해자 성명
      case 2: return func.getContent(value).inputB_8 // 사고장소
      case 3: return func.getContent(value).inputB_3 // 직종(재해자)
      case 4: return func.getContent(value).stdInfo.section // 작성부서
      case 5: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
    case '사업장명': return ['content$body.stdInfo.field_name*%[:default_skw]%']
    case '피해자 성명': return ['content$body.inputB_1*%[:default_skw]%']
    case '사고장소': return ['content$body.inputB_8*%[:default_skw]%']
    case '직종(재해자)': return ['content$body.inputB_3*%[:default_skw]%']
    case '작성부서': return ['content$body.stdInfo.section*%[:default_skw]%']
    }

    return []
  },
}
